import React from "react";
import { Container } from "reactstrap";

import {
  LitterIntro,
  LitterPage,
  ParentPedigree,
  VideoSection
} from "components/Litters/LitterComponents.js";
import SEO from "components/SEO/SEO.js";

const announcement = require("../../assets/img/dogs/litters/vr2027/announcement.jpg");
const pedigreeImage = require("../../assets/img/dogs/litters/vr2027/pedigree.png");
const rivalProfile = require("../../assets/img/dogs/profile-rival.jpg");
const venusProfile = require("../../assets/img/dogs/profile-venus3.jpg");

const parentHealthSummaries = [
  {
    name: "Rival",
    breed: "Border Collie",
    ofaUrl: "https://ofa.org/advanced-search/?appnum=2721208",
    results: [
      { label: "Hips", value: "OFA Excellent" },
      { label: "Elbows", value: "Normal" },
      { label: "Shoulders", value: "Normal" },
      { label: "Spine", value: "Normal" },
      { label: "DNA", value: "EAOD Carrier" }
    ]
  },
  {
    name: "Venus",
    breed: "Border Collie",
    ofaUrl: "https://ofa.org/advanced-search/?appnum=2263105",
    results: [
      { label: "Hips", value: "Pennhip .32/.35, OFA Good" },
      { label: "Elbows", value: "Normal" },
      { label: "Shoulders", value: "Normal" },
      { label: "Adv Cardiac", value: "Clear" },
      { label: "Eyes", value: "Clear w/ PTSO" },
      { label: "DNA", value: "Clear" }
    ]
  }
];

function VR2027Page() {
  return (
    <>
      <SEO
        title="Rival x Venus 2026/27 | Border Collie Puppies"
        description="Learn about the planned Rival x Venus 2026/27 border collie puppies from Endgame Sport Dogs near Raleigh NC, bred for friendly, athletic sport prospects with herding foundation."
        path="/litters/venus-rival-2027"
      />
      <LitterPage
        headerBg="vr2027"
        pageClassName="litter-detail-page litter-detail-page-modern"
        footerVariant="dark"
      >

        <section className="litter-detail-section litter-overview-section">
          <Container>
            <LitterIntro
              title="Venus × Rival"
              eyebrow="Planned Border Collie Litter - 2026/27"
              announcement={announcement}
              announcementAlt="Rival x Venus litter announcement"
              finalCopy={
                <p>
                  For more information about <a className="litter-inline-link" href="/dogs/venus">Venus</a>, view her individual page. For more information on Rival, contact Madison Lee or reach out to me if you would like to learn about this cross.
                </p>
              }
              healthParents={parentHealthSummaries}
              overviewCopy={
                <>
                  <p>Rival is a thoughtful, driven dog from proven working lines. He is level-headed and environmentally stable, demonstrated by his ability to perform disc and trick shows in large, busy crowds. He is friendly with people, including children, and takes new environments in stride. He has competed successfully in agility, being a part of the WAO team with his junior handler in 2026 and winning the Boundless Youth Championships team event. While most of his close relatives are working dogs, his half siblings have gone on to excel in agility, disc, and dock diving, and are known for being level-headed and naturally well-mannered. Like Rival, Venus is an exceptionally friendly dog who loves everyone she meets and will play sports with anyone. She has produced multiple offspring excelling in agility, dock diving, and flyball, including world team members and national champions. Coming from herding lines, both Rival and Venus have a lot of eye but are able to remain focused without becoming over-aroused ringside.</p>
                  <p>I'm expecting this breeding to produce friendly, athletic, and high drive puppies with the ability to excel in a variety of sports. Preference will be given to homes whose primary sport is agility. Both Rival and Venus have trained in herding and the puppies will be evaluated by a herding instructor before going to their new homes. Since I don't have the experience to provide herding-specific guidance, I will share each puppy's evaluation with owners who are interested in pursuing herding.</p>
                </>
              }
              variant="modern"
            />
            <ParentPedigree
              className=""
              parents={[
                { name: "Rival", breed: "Border Collie", image: rivalProfile },
                { name: "Venus", breed: "Border Collie", image: venusProfile, href: "/dogs/venus" }
              ]}
              pedigree={{
                image: pedigreeImage,
                href: "https://dogs.pedigreeonline.com/sundowns-rival-abc-541570-FeNiFJVR/pedigree?hypomating=rafter-w-venus-h6IMYZUB"
              }}
              variant="modern"
            />
          </Container>
        </section>

        <section className="litter-detail-section litter-media-section site-bg-dark-navy">
          <Container>
            <VideoSection
              title="Parent Videos"
              className=""
              variant="modern"
              videos={[
                { src: "https://www.youtube.com/embed/IlEptZZi-pw", caption: "Rival - Sport Video" },
                { src: "https://www.youtube.com/embed/DKkOrjwALxw", caption: "Rival - Sport Video" },
                { src: "https://www.youtube.com/embed/videoseries?si=GV-kfEHFHNrsgREr&list=PLta6k7s4hvnkVVH_22PYMxIzuBfPVVuWf", caption: "Venus - Video Playlist" },
                { src: "https://www.youtube.com/embed/a-rC0b1lkhA", caption: "Venus - Herding 2023" }
              ]}
            />
          </Container>
        </section>

        <section className="litter-detail-section litter-media-section litter-group-video-section site-bg-dark-navy">
          <Container>
            <VideoSection
              title="Related Dogs"
              className=""
              variant="modern"
              videos={[
                { src: "https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F868808256309318%2F&show_text=false&width=560&t=0", caption: "Cinco (Venus x Hop Sing)" },
                { src: "https://www.youtube.com/embed/6N2UZwqf1E0", caption: "Cool (Venus x Rip)" }
              ]}
            />
          </Container>
        </section>
      </LitterPage>
    </>
  );
}

export default VR2027Page;
